<script>
export default {
    name: 'AllowCookieBanner',
};
</script>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from '@/store/index.js';
import publicSiteUrl from '@/utils/public-site-url.ts';
import i18n from '@/plugins/i18n.ts';
import { instance } from '@/api/api.ts';
import useCookies from '@/composables/cookies/useCookies.ts';

const show = ref(false);

const store = useStore();

const versionActual = computed(() => store.state.version.actual);

const message = computed(() => {
    const link = publicSiteUrl.serviceLink('terms-of-service');

    return i18n.t('accept cookies message', {
        linkOpen:  `<a href='${link}' target='_blank'>`,
        linkClose: '</a>',
    });
});

function accept() {
    setCookie('1');
    show.value = false;
}

function setCookie(value) {
    instance.get(`/allow-consent-cookies?value=${value}`);
}

const cookies = useCookies();

onMounted(() => {
    if (!cookies.get('allowConsentCookies')) {
        setTimeout(() => {
            show.value = true;
        }, 1500);
    }
});
</script>

<template>
    <BaseBanner
        :data-test="dataTest()"
        :show="show && versionActual"
        :icon="{ name: 'cookie-bite', prefix: 'fas' }"
        :text="message"
        :button-text="i18n.t('accept cookies info button')"
        :button-link="publicSiteUrl.serviceLink('gdpr')"
        closable
        @close="accept"
    />
</template>
